// This is a service that uses the Angular Hono client to make requests to the Dealcore API.
// And this is the only exception for eslint-disable-next-line @nx/enforce-module-boundaries!!!
// eslint-disable-next-line @nx/enforce-module-boundaries
import type { DealcoreType } from '@hyundai/dealcore-lib/router';
// ********************************************************************************************
// ********************************************************************************************
import { HttpClient } from '@angular/common/http';
import { inject, Injectable, InjectionToken, type Provider } from '@angular/core';
import { Store } from '@ngrx/store';
import { injectAngularHonoClient } from '@pixelgenau/ngx-hono';
import { firstValueFrom, map, Observable } from 'rxjs';
import { state } from '../+state/login/login.reducer';
import { injectPartnerWebUrl } from '../providers/partner-web-url.token';
import { isHWS } from '../providers/platform.token';
import { DEALCORE_API_CONFIG } from './dealer-api.service';

export interface UserApiConfig {
    baseUrl: string;
}

export const USER_API_CONFIG = new InjectionToken<UserApiConfig>('USER_API_CONFIG');

export function provideUserApiConfig(config: UserApiConfig): Provider {
    return { provide: USER_API_CONFIG, useValue: config };
}
@Injectable({ providedIn: 'root' })
export class UserApiService {
    protected readonly store = inject(Store);
    protected readonly authToken = this.store.selectSignal(state.selectAuthToken);

    protected readonly http = inject(HttpClient);
    protected readonly apiConfig = inject(DEALCORE_API_CONFIG);
    protected readonly api = injectAngularHonoClient<DealcoreType>({
        url: this.apiConfig.baseUrl,
        authToken: this.authToken,
        withCredentials: true,
    });
    protected readonly partnerWebUrl = injectPartnerWebUrl();
    protected readonly isHWS = isHWS();

    protected postAuth<T>(url: string, body: FormData | Record<string, unknown>): Observable<T> {
        return this.http.post<T>(`${this.apiConfig.baseUrl}/${url}`, body, {
            headers: this.authToken()
                ? {
                      Authorization: `Bearer ${this.authToken()}`,
                  }
                : undefined,
        });
    }

    async sendLoginCode(email: string) {
        // return this.api.login.sendCode.$post({ json: { email } }).then((res) => res.json());
        const request = await this.api.login.sendCode.$post({ json: { email } });
        return request.json();
    }

    async verifyLoginCode(email: string, code: string) {
        // return this.api.login.verifyCode.$post({ json: { email, code } }).then((res) => res.json());
        const request = await this.api.login.verifyCode.$post({ json: { email, code } });
        return request.json();
    }

    async isAuthenticated() {
        return this.api.login.isAuthenticated.$post().then((res) => res.json());
    }

    async getUserInfo() {
        return this.api.login.userInfo.$get().then((res) => res.json());
    }

    async getDealerSlug() {
        return this.api.login.dealerSlug.$get().then((res) => res.json());
    }

    async getFormId(name: string) {
        return this.api.form[':name'].$get({ param: { name } }).then((res) => res.json());
    }

    async getPartnerWebJwt() {
        if (this.isHWS) return null;
        return firstValueFrom(
            this.http
                .get<{ jwt: string | null }>(`${this.partnerWebUrl}/api/jwt`, {
                    withCredentials: true,
                })
                .pipe(map((res) => res.jwt)),
        );
    }
}
